import {termTextService} from "../network/services/term-text.service";

export default {
  namespaced: true,
  state: {
    modalOpenState: false,
    currentTab: 0,
    termOfSales: [],
    termLegals: [],
    loading: false
  },
  mutations: {
    OPEN_MODAL (state) {
      state.modalOpenState = true;
    },
    CLOSE_MODAL (state) {
      state.modalOpenState = false;
    },
    SET_LOADING (state, payload) {
      state.loading = !!payload;
    },
    SET_SALES (state, texts) {
      state.termOfSales = texts;
    },
    SET_LEGALS (state, texts) {
      state.termLegals = texts
    },
    SET_TAB (state, tab) {
      state.currentTab = parseInt(tab) % 2;
    }
  },
  actions: {
    async fetch (context) {
      context.commit('SET_LOADING', true);
      const response = await termTextService.fetch(context.rootState.lang.currentLang);
      const sales = response.get('TermOfSales.many', []);
      const legals = response.get('TermLegal.many', []);
      context.commit('SET_SALES', sales);
      context.commit('SET_LEGALS', legals);
      context.commit('SET_LOADING', false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/legal-modal.store.js